import { Box } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyLayout } from '../../../../../components/new-design/layout/VyLayout';
import { withSuspenseBoundary } from '../../../../../components/utility/SuspenseBoundary';
import { useCustomer } from '../../../../../hooks/requests/use-customer';
import { useParamsDynamicInvoiceIdOrDefault } from '../../../../../hooks/use-dynamic-invoice-id';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { CustomersPageNavigationLayout } from './customer-layout-components/CustomersPageLayout/CustomersPageNavigationLayout';
import { CustomersSideNav } from './customer-layout-components/CustomersSideNav/CustomersSideNav';

type CustomerLayoutProps = {
  children: React.ReactNode;
};

const CustomerLayout: React.FC<CustomerLayoutProps> = ({ children }) => {
  const customerId = useParamsDynamicInvoiceIdOrDefault(undefined);
  const { data } = useCustomer(customerId, { suspense: false });

  const navigate = useVyNavigate();

  return (
    <>
      <Helmet>
        <title>Customers</title>
      </Helmet>

      <VyLayout
        sx={{
          paddingTop: 0,
        }}
        navigation={
          <CustomersPageNavigationLayout
            customer={data?.customer}
            relatedCustomers={data?.children}
            onBackClick={() => navigate(-1)}
          />
        }
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', paddingTop: '16px' }}>
          <CustomersSideNav />
          <Box sx={{ paddingTop: '16px', flex: 1, minHeight: 0 }}>{children}</Box>
        </Box>
      </VyLayout>
    </>
  );
};

const CustomersPageWithSuspenseBoundary = withSuspenseBoundary(CustomerLayout);

export { CustomersPageWithSuspenseBoundary as CustomerLayout };
